export enum UserRoles {
  WorkspacesPublish = "Workspace.Publish",
  WorkspacesReadWrite = "Workspace.ReadWrite.All",
  WorkspacesRead = "Workspace.Read.All",
}
